/* eslint-disable camelcase */
import React, { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ProfessionalsEmployeeDetails from '../../../components/professionals/ProfessionalsEmployeeDetails';
import { useGetProfessionalQuery, useUpdateEmployeeIDsMutation } from '../../../redux/managementCompanyWorkforce';
import FlexProfessionalNotes from './FlexProfessionalNotes';
import EmployeeIdsSection from './EmployeeIdsSection';
import IsAuthorizedForManagementCompany from '../../../components/IsAuthorizedForManagementCompany/IsAuthorizedForManagementCompany';
import Permissions from '../../../constants/Permissions';
import { showNotification } from '../../../redux/notification';

import '../../../components/professionals/ProfessionalsEmployeeDetails.scss';
import './FlexProfessionalNotes.scss';

const FlexProfessionalsEmployeeDetails = ({ setShowEditIcon }) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const { professionalId: caregiverId, managementCompanyId } = useParams();
	const { data: professional, isFetching, error } = useGetProfessionalQuery(
		{ managementCompanyId, caregiverId },
		{
			refetchOnMountOrArgChange: true
		}
	);

	useEffect(() => {
		if (error) {
			dispatch(showNotification('error', error.data?.errors?.[0].message || 'Professional is not enabled for flex'));
			history.goBack();
		}
	}, [error]);

	const EmployeeIdsSectionComponent = useCallback(
		() => (
			<EmployeeIdsSection
				data={professional.employee_ids}
				managementCompanyId={managementCompanyId}
				caregiverId={caregiverId}
				updateEmployeeIDsMutation={useUpdateEmployeeIDsMutation}
			/>
		),
		[professional]
	);

	return (
		<div className="flex-professional-employee-details">
			<ProfessionalsEmployeeDetails
				professional={professional}
				isFetching={isFetching}
				setShowEditIcon={setShowEditIcon}
				isFlex
				EmployeeIdsSection={EmployeeIdsSectionComponent}
			/>
			<IsAuthorizedForManagementCompany
				exactPermission={Permissions.WORKFORCE_NOTES_VIEW}
				managementCompanyId={managementCompanyId}
			>
				<FlexProfessionalNotes
					managementCompanyId={managementCompanyId}
					caregiverId={caregiverId}
					caregiverName={`${professional?.first_name} ${professional?.last_name}`}
					isFetching={isFetching}
				/>
			</IsAuthorizedForManagementCompany>
		</div>
	);
};

export default FlexProfessionalsEmployeeDetails;
